import React, { useEffect, useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { logDev } from "../utils/logger.js";

const SuccesPaiement = () => {
  const { groupeId: paramId } = useParams();
  const groupeId = paramId || sessionStorage.getItem("groupeId");
  
  logDev("🧭 SuccesPaiement monté", { groupeId });
  
  const [groupe, setGroupe] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!groupeId) {
      logDev("❌ Aucun groupeId reçu dans useParams");
      setLoading(false);
      return;
    }

    logDev("📥 Chargement du groupe après prolongation", { groupeId });

    axios.get(`${process.env.REACT_APP_API}/groupes/${groupeId}`)
      .then(res => {
        setGroupe(res.data);

      setLoading(false);

      logDev("✅ Groupe chargé avec succès", res.data);

      })

      .catch(err => {
        logDev("❌ Erreur chargement groupe après paiement", { message: err.message });
        setLoading(false);
      });
      
  }, [groupeId]);

    if (loading) return <Box sx={{ p: 4, textAlign: "center" }}><CircularProgress /></Box>;
    if (!groupeId) return <Typography sx={{ p: 4 }}>❌ Aucun identifiant de groupe fourni.</Typography>;
    if (!groupe) return <Typography sx={{ p: 4 }}>❌ Groupe introuvable ou erreur serveur.</Typography>;

  return (
    <Box sx={{ maxWidth: 600, margin: "auto", mt: 4, p: 2, textAlign: "center" }}>
      
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        ✅ Paiement réussi !
      </Typography>

      <Typography variant="h6" gutterBottom>
        {groupe.emoji || "🧩"} {groupe.nom}
      </Typography>

      <Typography sx={{ color: groupe.couleur || "#71685e", mb: 2 }}>
        Vous pouvez maintenant continuer à utiliser ce groupe.
      </Typography>

      <Button
        variant="outlined"
        onClick={() => {
          sessionStorage.removeItem("groupeId");
          sessionStorage.removeItem("role");
          sessionStorage.removeItem("nom");
          logDev("🧹 sessionStorage nettoyé après clic retour sondage");    
          navigate(`/survey`)
        }}
        sx={{
          borderColor: groupe.couleur || "#71685e",
          color: groupe.couleur || "#71685e",
          padding: "8px 16px",
          borderRadius: "6px",
          fontWeight: "bold"
        }}
      >
        🔙 Voir le sondage
      </Button>
    </Box>
  );
};

export default SuccesPaiement;
